/* eslint-disable camelcase */
import { type UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import ToastComponent from '../../components/toast';
import {
  TerminationRuleService,
  Wealthlane_AwardService_Dtos_Plan_TerminationRuleItemDto,
} from '../../services/wealthlane-award-services';

const usePutTerminationRules = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  closeModal: () => void,
  terminationRuleSetId?: string,
  planId?: string
): UseMutationResult<boolean | string | undefined, unknown, any, unknown> => {
  const queryClient = useQueryClient();
  return useMutation(
    async (data: any) => {
      const payload = {
        planId: planId,
        terminationRuleItems: data,
      };
      // If terminationRuleSetId exists, use PUT API (update), otherwise use POST API (create)
      if (terminationRuleSetId) {
        return await handleRequest(
          TerminationRuleService.putApiAwardApiAppTerminationRuleTerminationRule(data)
        );
      } else {
        return await handleRequest(
          TerminationRuleService.postApiAwardApiAppTerminationRulePlanTerminationRules(payload)
        );
      }
    },
    {
      onSuccess: (response) => {
        if (response != null) {
          const message = 'Termination Rule Edited.';
          toast.success(<ToastComponent label='Success' message={message} />);
          closeModal();
        }
      },
      onError: (err) => {
        console.log('error', err);
      },
    }
  );
};

export default usePutTerminationRules;
